import * as Icons from "lucide-react";
import { INDUSTRIES } from "@/lib/site";

export const Industries = () => (
  <section id="industries" className="py-24 lg:py-32" data-testid="industries-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="text-center max-w-3xl mx-auto">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-brand-purple">Industries we serve</div>
        <h2 className="section-heading text-3xl sm:text-4xl lg:text-5xl mt-3 text-slate-900">
          Domain expertise across <span className="text-gradient">10+ industries</span>
        </h2>
      </div>

      <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
        {INDUSTRIES.map((ind) => {
          const Icon = Icons[ind.icon];
          return (
            <div
              key={ind.name}
              className="card-lift bg-white rounded-2xl border border-slate-100 p-5 text-center flex flex-col items-center gap-3"
              data-testid={`industry-${ind.name.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
            >
              <div className="w-12 h-12 rounded-2xl bg-brand-gradient-soft flex items-center justify-center text-brand-purple">
                <Icon className="w-5 h-5" />
              </div>
              <div className="text-sm font-semibold text-slate-800">{ind.name}</div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
